export const DEMO_USER = {
  id: 'demo_user_001',
  platform_type: 'DEMO',
  name: '김도현',
  email: 'demo@shift2me.com',
  age_range: '20~29',
  gender: 'male',
  phone_number: '010-1234-5678',
  isDemo: true,
};

export const DEMO_EPA_TEST = {
  tid: 'demo_tid_98421',
  owner_platform: 'DEMO',
  owner_id: 'demo_user_001',
  nickname: '도현',
  gender: 'male',
  age: 27,
  notification_agree: false,
  notified: 0,

  // ⭐ 내가 생각하는 나 (ISTP + 개발자 + 과묵 + 논리 기반)
  keyword_myself: [12, 30, 25, 37, 48],
  // 개복치 / 너드 / 차분한 / 극강의 효율충 / 내향적인

  // ⭐ 내가 되고 싶은 나 (자신감↑, 밝음, 리더십, 유쾌함)
  keyword_want: [1, 22, 46, 47, 10],
  // GOAT / 도전적인 / 유쾌한 / 친근한 / 인간 나무위키

  // ⭐ 남들이 나를 볼 것 같은 모습 (침착, 논리적, 조용, 효율적, 책임감)
  keyword_others: [25, 16, 48, 38, 18],
  // 차분한 / 논리왕 / 내향적인 / 믿음직한 / 철저한

  replies: [
    // 1. 27살 남성 친구(ENFP) — 활발함, 장난기, 개발자 동기
    {
      anonymous: false,
      nickname: '재훈',
      gender: 'male',
      relationship: '친구',
      age_range: '20대',
      keyword_selected: [16, 37, 48, 32, 46],
      keyword_detail: [
        { id: 16, reason: '토론하면 항상 논리적으로 정리해서 말하잖아' },
        { id: 37, reason: '개발할 때 작업 효율은 진짜 미쳤다' },
        { id: 48, reason: '겉으론 무덤덤해 보이지만 친하면 따뜻함' },
        { id: 32, reason: '필요할 땐 과감하게 밀어붙이는 성향이 있어' },
        { id: 46, reason: '티는 안 내는데 은근 유머 감각 있음' },
      ],
      keyword_in_myself: [37, 48],
      keyword_not_in_myself: [16, 32, 46],
      keyword_in_want: [46],
      keyword_not_in_want: [16, 37, 48, 32],
      keyword_in_others: [16, 48],
      keyword_not_in_others: [37, 32, 46],
      one_line_intro: '겉으론 차갑지만 알수록 매력적인 숨은 핵인싸 타입',
      reply_time: '2025-01-15T14:30:00',
    },

    // 2. 28살 여성 회사 동기(ESTJ) — 체계적, 규칙적, 관찰력 높음
    {
      anonymous: false,
      nickname: '서연',
      gender: 'female',
      relationship: '지인',
      age_range: '20대',
      keyword_selected: [18, 25, 38, 16, 10],
      keyword_detail: [
        { id: 18, reason: '일 처리할 때 디테일 하나도 안 놓쳐' },
        { id: 25, reason: '불필요한 말 없이 안정적으로 일함' },
        { id: 38, reason: '위급한 순간에도 믿고 맡길 만해' },
        { id: 16, reason: '회의 때 논리적으로 정리해주는 부분이 좋음' },
        { id: 10, reason: '분야 지식이 넓어서 물어보면 바로바로 알려줘' },
      ],
      keyword_in_myself: [25],
      keyword_not_in_myself: [18, 38, 16, 10],
      keyword_in_want: [10],
      keyword_not_in_want: [18, 25, 38, 16],
      keyword_in_others: [18, 25, 38, 16],
      keyword_not_in_others: [10],
      one_line_intro: '과묵하지만 믿고 함께 일할 수 있는 든든한 실력러',
      reply_time: '2025-01-16T09:15:00',
    },

    // 3. 50대 여성 가족(어머니, ISFJ) — 따뜻함, 안정감, 보수적
    {
      anonymous: true,
      nickname: '익명',
      gender: 'female',
      relationship: '가족',
      age_range: '50대',
      keyword_selected: [18, 25, 42, 35, 1],
      keyword_detail: [
        { id: 18, reason: '어릴 때부터 맡은 일은 끝까지 책임지던 모습' },
        { id: 25, reason: '성격이 말수는 적어도 마음은 따뜻함' },
        { id: 42, reason: '가족을 누구보다 챙기려는 마음을 느낄 수 있어' },
        { id: 35, reason: '성공해도 겸손함을 유지하는 점이 자랑스러워' },
        { id: 1, reason: '무슨 일을 하든 최고가 되고 싶어 하는 노력파야' },
      ],
      keyword_in_myself: [25],
      keyword_not_in_myself: [18, 42, 35, 1],
      keyword_in_want: [1],
      keyword_not_in_want: [18, 25, 42, 35],
      keyword_in_others: [18, 25],
      keyword_not_in_others: [42, 35, 1],
      one_line_intro: '겉보다 속이 훨씬 따뜻하고 성실한 듬직한 아들',
      reply_time: '2025-01-16T20:45:00',
    },

    // 4. 23살 여성 동생(ISTJ) — 직설, 관찰력, 냉철
    {
      anonymous: false,
      nickname: '지은',
      gender: 'female',
      relationship: '가족',
      age_range: '20대',
      keyword_selected: [48, 16, 25, 32, 14],
      keyword_detail: [
        { id: 48, reason: '집에서는 거의 말 안 함… 인정?' },
        { id: 16, reason: '필요한 건 정확하게 판단하는 편' },
        { id: 25, reason: '웬만한 상황에서도 침착해서 부럽다' },
        { id: 32, reason: '결단력은 은근히 강함' },
        { id: 14, reason: '기술 좋아하고 늘 새 기계 사는 거 보면 앱등이 맞아' },
      ],
      keyword_in_myself: [48, 25],
      keyword_not_in_myself: [16, 32, 14],
      keyword_in_want: [],
      keyword_not_in_want: [48, 16, 25, 32, 14],
      keyword_in_others: [48, 16, 25],
      keyword_not_in_others: [32, 14],
      one_line_intro: '말수는 적어도 행동은 정확한 집안 대표 냉정러',
      reply_time: '2025-01-17T11:20:00',
    },

    // 5. 29살 여성 애인(ENFP) — 감성, 활발, 정서적 피드백 중시
    {
      anonymous: false,
      nickname: '민아',
      gender: 'female',
      relationship: '애인',
      age_range: '20대',
      keyword_selected: [42, 47, 25, 38, 46],
      keyword_detail: [
        { id: 42, reason: '말은 적어도 감정은 잘 이해해주니까 고마워' },
        { id: 47, reason: '낯가리지만 친해지면 누구보다 다정함' },
        { id: 25, reason: '내가 불안할 때 늘 잔잔하게 안정감을 줘' },
        { id: 38, reason: '내가 힘들 때 말없이 챙겨주는 든든함' },
        { id: 46, reason: '무심한 듯 웃길 때가 있어서 좋음' },
      ],
      keyword_in_myself: [25],
      keyword_not_in_myself: [42, 47, 38, 46],
      keyword_in_want: [47, 46],
      keyword_not_in_want: [42, 25, 38],
      keyword_in_others: [25, 38],
      keyword_not_in_others: [42, 47, 46],
      one_line_intro: '말보다 행동으로 따뜻함을 보여주는 사람',
      reply_time: '2025-01-17T19:30:00',
    },

    // 6. 35살 남성 백엔드 동료(INFP) — 조용, 따뜻, 감정 기반
    {
      anonymous: false,
      nickname: '태윤',
      gender: 'male',
      relationship: '지인',
      age_range: '30대',
      keyword_selected: [38, 18, 30, 25, 48],
      keyword_detail: [
        { id: 38, reason: '프로젝트 막힐 때 의외로 도움을 많이 줌' },
        { id: 18, reason: '코드 하나도 대충 안 넘기는 성격' },
        { id: 30, reason: '기술 얘기 시작하면 깊이가 장난 아님' },
        { id: 25, reason: '회의 때도 항상 침착하고 안정적' },
        { id: 48, reason: '혼자 일하는 걸 좋아하지만 팀 작업도 잘 함' },
      ],
      keyword_in_myself: [30, 25, 48],
      keyword_not_in_myself: [38, 18],
      keyword_in_want: [],
      keyword_not_in_want: [38, 18, 30, 25, 48],
      keyword_in_others: [38, 18, 25, 48],
      keyword_not_in_others: [30],
      one_line_intro: '겉은 무심해도 실력과 성실함이 확실한 개발자',
      reply_time: '2025-01-17T22:10:00',
    },

    // 7. 30살 남성 기획자(ENTJ) — 리더십, 직설, 빠른 판단
    {
      anonymous: false,
      nickname: '기범',
      gender: 'male',
      relationship: '지인',
      age_range: '30대',
      keyword_selected: [16, 37, 38, 10, 22],
      keyword_detail: [
        { id: 16, reason: '회의 때 컨셉 잡아주면 바로 논리적으로 구조화함' },
        { id: 37, reason: '불필요한 과정을 아주 싫어함… 효율 그 자체' },
        { id: 38, reason: '어떤 문제도 침착하게 해결책을 냄' },
        { id: 10, reason: '기술적 근거를 명확하게 설명해줘서 작업하기 좋음' },
        { id: 22, reason: '진득하고도 도전적이어서 믿음이 간다' },
      ],
      keyword_in_myself: [37],
      keyword_not_in_myself: [16, 38, 10, 22],
      keyword_in_want: [10, 22],
      keyword_not_in_want: [16, 37, 38],
      keyword_in_others: [16, 38],
      keyword_not_in_others: [37, 10, 22],
      one_line_intro: '기획자 입장에서 가장 일하기 편한 타입의 개발자',
      reply_time: '2025-01-18T10:30:00',
    },
  ],
};

// static data for demo
export const DEMO_STATS = {
  total_num: 15247,
  test_count: 8924,
  reply_count: 6323,
};

// EPA keywords
export const EPA_KEYWORDS = {
  1: ['GOAT', '🏆'],
  2: ['알잘딱깔센', '🙋🏻‍♀️'],
  3: ['Super Shy', '🫣'],
  4: ['Kitsch', '💖'],
  5: ['느긋한', '🧘🏻‍♀️'],
  6: ['대가리꽃밭', '🌸'],
  7: ['T발 C', '🤖'],
  8: ['예민보스', '😬'],
  9: ['완벽주의', '💯'],
  10: ['인간 나무위키', '🌲'],
  11: ['엄근진', '🙇🏻‍♀️'],
  12: ['개복치', '🐟'],
  13: ['청소광', '🧹'],
  14: ['앱등이', '📱'],
  15: ['마더테레사', '👩🏻‍🍼'],
  16: ['논리왕', '📖'],
  17: ['참을성 있는', '🚽'],
  18: ['철저한', '🕵🏻'],
  19: ['ADHD', '😵‍💫'],
  20: ['파워 J', '📆'],
  21: ['농협은행', '🏦'],
  22: ['도전적인', '👊🏻'],
  23: ['줏대있는', '✊🏻'],
  24: ['대문자 F', '💦'],
  25: ['차분한', '😌'],
  26: ['분위기 맛집', '🌄'],
  27: ['독고다이', '💪🏻'],
  28: ['으른스러운', '👴🏻'],
  29: ['나 뭐 돼', '👍🏻'],
  30: ['너드', '🤓'],
  31: ['자의식 과잉', '🥳'],
  32: ['용감한', '😜'],
  33: ['텐션과다', '😣'],
  34: ['창의적인', '😖'],
  35: ['겸손한', '😔'],
  36: ['띠꺼운', '😡'],
  37: ['극강의 효율충', '🤠'],
  38: ['믿음직한', '🤓'],
  39: ['낄빠 못하는', '😎'],
  40: ['인간 리트리버', '🐕'],
  41: ['쎄믈리에', '😤'],
  42: ['정이 많은', '🥹'],
  43: ['투머치띵커', '🤔'],
  44: ['감성적인', '🍂'],
  45: ['비관적인', '🧐'],
  46: ['유쾌한', '😚'],
  47: ['친근한', '😙'],
  48: ['내향적인', '🤫'],
  49: ['자낳괴', '💸'],
  50: ['무해한', '🥺'],
  51: ['4차원적인', '😵‍💫'],
  52: ['영악한', '🎭'],
  53: ['foxy 그 잡채', '🦊'],
  54: ['다혈질의', '🤬'],
  55: ['수다스러운', '🗣️'],
  56: ['기업은행', '🙈'],
  57: ['음침한', '🥴'],
  58: ['언변이 좋은', '🥸'],
  59: ['질투많은', '💋'],
  60: ['그냥 쎄한', '👿'],
};
